/**
 * Copy e endereco do "Registro de Estudos" — o produto que ate a r6-28 se chamava
 * "MedHunter Manual" (spec r6/28, R5).
 *
 * Fonte unica do NOME e do CAMINHO para quem escreve texto de tela ou monta link
 * interno. A r6-26 (copies tela a tela) le daqui em vez de repetir a string.
 *
 * O que NAO muda, de proposito (R4): a tabela `manual_entries`, a rota da API
 * `/api/v1/manual_entries`, o componente `MedHunterManualTab`, o hook
 * `useManualEntries`, os tipos de `features/manualEntries/` e a chave de cache
 * `['manual-entries', ...]`. Esta task troca nome de produto e endereco da SPA,
 * nao identidade de dado — renomear simbolo aqui quebraria a r6-18 (idempotencia)
 * e a r6-19 (passo de escolha do "Adicionar"), entregues na mesma leva.
 *
 * `MANUAL_LEGACY_ROUTE` existe porque `/app/manual` precisa continuar respondendo
 * (R3): ha push ja entregue no dispositivo do aluno com esse caminho no payload.
 * Ele e a forma ABSOLUTA desse caminho e nao tem consumidor de producao: em
 * `routes/index.tsx` a entrada do redirect declara `path: 'manual'` literal, porque
 * rota filha de `/app` exige segmento relativo. Quem le daquele arquivo e
 * `MANUAL_ROUTE`, o ALVO do `<Navigate>`. Nenhum link interno deve apontar para a
 * rota velha.
 */
export const MANUAL_COPY = {
  /** Nome do produto. Caixa alta nas duas palavras, como os vizinhos do menu (§4.2). */
  title: 'Registro de Estudos',
  /** Subtitulo da tela, literal e inalterado pela renomeacao (R2). */
  subtitle: 'Registre seus estudos e simulados manualmente',
} as const

/** Endereco atual da tela na SPA (§4.1). */
export const MANUAL_ROUTE = '/app/registro-estudos'

/** Endereco antigo, mantido vivo por redirect permanente (R3). Nao use em link novo. */
export const MANUAL_LEGACY_ROUTE = '/app/manual'

/**
 * Registro de provas e simulados feitos FORA da plataforma (r7-23, MH-R07.1 [28:02]).
 *
 * Pedro: "a gente depois troca o nome pra provas / simulados" — o aluno registra aqui a
 * prova do cursinho, nao so simulado. So o texto de tela muda: o tipo `test`, a sub-aba
 * `simulados` na URL, a tabela `test_and_simulations` e a rota da API ficam.
 */
export const MANUAL_TEST_COPY = {
  /** Card do passo de escolha do "Adicionar" e rotulo do tipo. */
  entryLabel: 'Prova / Simulado',
  /** Sub-aba do Registro de Estudos. */
  subTabLabel: 'Provas / Simulados',
  addTitle: 'Adicionar prova / simulado',
  editTitle: 'Editar prova / simulado',
  nameLabel: 'Nome da prova / simulado',
  totalLabel: 'Total de provas / simulados',
  emptyTitle: 'Nenhuma prova ou simulado registrado',
  emptyCta: 'Adicionar prova / simulado',
  filterPlaceholder: 'Filtrar por nome da prova / simulado...',
  filterAriaLabel: 'Filtrar por nome da prova / simulado',
  filteredEmpty: 'Nenhuma prova ou simulado encontrado com o filtro selecionado',
  deleteConfirm: 'Tem certeza que deseja excluir esta prova / simulado?',
  saveError: 'Não foi possível salvar a prova / simulado.',
} as const
